import { render, staticRenderFns } from "./BCXInfoCollapsible.vue?vue&type=template&id=4bdda4e4"
import script from "./BCXInfoCollapsible.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXInfoCollapsible.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BCXInfoCollapsible.vue?vue&type=custom&index=0&blockType=markdown-style&lang=scss&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports